import React, { useEffect, useRef } from "react";
import TimerIcon from "../../icons/TimerIcon";

interface Props {
  items: string[];
  onSelect: (value: string) => void;
  isRecentSearch?: boolean;
  selectedIndex: number;
  setSelectedIndex: (index: number | ((prev: number) => number)) => void;
}

const SearchDropdown: React.FC<Props> = ({
  items,
  onSelect,
  isRecentSearch,
  selectedIndex,
  setSelectedIndex,
}) => {
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  // Scroll selected item into view
  useEffect(() => {
    if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  return (
    <div className="qs_sd_search">
      {items.map((item, index) => (
        <div
          key={item}
          ref={(el) => {
            itemRefs.current[index] = el;
          }}
          className={`qs_sd_search_item qs_pointer ${
            index === selectedIndex ? "active" : ""
          }`}
          onClick={() => onSelect(item)}
          onMouseEnter={() => setSelectedIndex(index)}
        >
          {isRecentSearch && <TimerIcon />}
          {item}
        </div>
      ))}
    </div>
  );
};

export default SearchDropdown;
